<template>
  <div :id="robotRootId" v-if="isVisible">
    <div :id="eleId" class="robotItemHelper" draggable="true">
      <div class="title">
        <img @click="handleDialog('open')" title="点击展开窗口" :src="roboticonIcon" alt="" class="robotIcon">
        <span style="font-size:18px;font-weight:600;color:#0084ff;">智能导办助手</span>
        <div :style="status==='open'?'margin-left:165px;':'margin-left:245px;'">
          <span v-if="status==='open'" @click="handleDialog('retract')" style="cursor: pointer;margin-right:15px;"><img :src="downIcon" alt=""></span>
          <span @click="closeRobot" style="cursor: pointer;"><img :src="delIcon" alt=""></span>
        </div>
      </div>
      <div class="cont">
        <div class="talkMain">
          <!-- 欢迎语 -->
          <div class="main_title" v-if="robotType === '1'">
            <div>{{ this.quitTitle }}</div>
          </div>
          <div class="main_title" v-if="robotType === '2'">
            <div v-html="parseMarkdown(this.materialTitle)"></div>
          </div>
          <div class="main_title" v-if="robotType === '3'">
            <div>您好，欢迎使用智能导办助手，我可以为您提供办事咨询服务，您当前正在浏览<span class="">{{ this.itemBean.itemName }}</span>的办事指南，请问您有什么问题？</div>
          </div>
          <!-- 对话 -->
          <div v-for="(item,index) in list" :key="index">
            <div class="main_user" v-if="item.role==='user'">
              <div class="user_question" v-html="item.msg"></div>
              <div class="userIcon"><img :src="userIcon" alt=""></div>
            </div>
            <div class="main_cont" v-if="item.role==='robot'">
              <!-- 智能体消息 -->
              <div class="cont_select" v-if="item.msg" v-html="parseMarkdown(item.msg)"></div>
              <div v-if="item.showfillbtn" :class="[list.length-1>index?'disabled':'']">
                <div class="radiobtn" @click="handleSubmit()"><span class="textdiv"> 是 </span></div>
                <div class="radiobtn" @click="consultQuestion()"><span class="textdiv"> 否 </span></div>
              </div>
              <div v-if="item.rillMark" :class="[list.length-1>index?'disabled':'']">
                <div class="radiobtn" @click="rillMark()"><span class="textdiv"> 是 </span></div>
              </div>
              <!-- 智能体消息 -->
              <div class="cont_select" v-if="item.situation">
                <div style="font-weight: bold; list-style: none" :class="[item.activeStyle?'activeStyle':'']">
                  <span style="margin-right:3px">{{ item.situation.situationName }}</span>
                  <div style="margin-top: 10px;" :class="[list.length-1>index?'disabled':'']">
                    <a-radio-group v-if="item.situation.childList && item.situation.selectType === 'single'" v-model="item.situation.checked" @change="handleRadioChecked(item.situation.checked, item.situation)">
                      <a-radio-button
                        v-for="sub in item.situation.childList"
                        :key="sub.iid"
                        :value="sub.iid"
                        :class="[item.situation.checked&&sub.iid===item.situation.checked?'selectBtn':'unselectBtn']"
                        style="border:1px solid #ddd;border-radius:3px;margin-right: 8px;margin-bottom: 8px;">
                        {{ sub.situationName }}
                      </a-radio-button>
                    </a-radio-group>
                    <a-checkbox-group v-if="item.situation.childList && item.situation.selectType === 'multiple'" v-model="item.situation.checked">
                      <a-checkbox
                        v-for="sub in item.situation.childList"
                        :key="sub.iid"
                        @click="handleStyleClick(sub, item.situation.childList)"
                        :class="[item.situation.checked&&item.situation.checked.includes(sub.iid)?'selectBtn':'unselectBtn']"
                        :value="sub.iid"
                        style="border:1px solid #ddd;padding:4px 10px;border-radius:3px;margin-right: 8px;margin-bottom: 8px;margin-left: 0px;">
                        {{ sub.situationName }}
                      </a-checkbox>
                      <br>
                      <div class="radiobtn" @click="handleCheckboxChange(item.situation.checked, item.situation)"><span class="textdiv"> 选好了 </span></div>
                    </a-checkbox-group>
                  </div>
                </div>
              </div>
              <!-- 无响应消息 -->
              <span class="focus-animation" v-if="!item.msg&&!item.situation"></span>
            </div>
          </div>
        </div>
        <!-- 输入框 -->
        <div class="input">
          <div :style="robotType==='1'?'height:40px;margin-bottom:10px;text-align: center;':'height:40px;display:flex;justify-content:center;margin-bottom:10px;'">
            <img v-if="showStop" class="stoptwo" :src="stoptalkIcon" alt="" @click="stopTalk">
            <div v-if="showQuit" class="quit" @click="quitBd">
              确定
            </div>
          </div>
          <textarea
            v-model="question"
            id="q"
            name="q"
            :placeholder="placeholderValue"
            @keydown="handleKeyDown"
            @blur="blurPlaceholder"
            @focus="clearPlaceholder"></textarea>
          <img class="pullimg" :src="pullIcon" alt="" @click="pullQuestion(question)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import downIcon from '@/assets/jiopweb/down.png'
import pullIcon from '@/assets/jiopweb/pull.png'
import delIcon from '@/assets/jiopweb/delete.png'
import stoptalkIcon from '@/assets/jiopweb/stoptalk.png'
import roboticonIcon from '@/assets/jiopweb/roboticon1.png'
import userIcon from '@/assets/jiopweb/user.png'
import aianswerIcon from '@/assets/jiopweb/aianswer.png'
import copyIcon from '@/assets/jiopweb/copy.png'
import { sseAPI } from '@/api/robot/sse.js'
import marked from 'marked' // 引入 marked 库
import hljs from 'highlight.js'
import { cloneDeep } from 'lodash'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import { jiopAPI } from '@/api/jiopweb/jiop'

export default {
  name: 'RobotHelper',
  components: {

  },
  props: {
    robotRootId: {
      type: String,
      default: 'OAy0BmlubzJiwvozkgW63',
      required: true
    },
    eleId: {
      type: String,
      default: 'RobotHelper111111'
    },
    robotType: {
      type: String,
      default: '3'
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    itemBean: {
      type: Object,
      default: () => ({ itemName: '' })
    },
    taskServiceObj: {
      type: String,
      default: ''
    },
    handleType: {
      type: String,
      default: 'item'
    },
    situationDataBeanList: {
      type: Array,
      default: () => []
    },
    materialList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      downIcon,
      pullIcon,
      delIcon,
      stoptalkIcon,
      roboticonIcon,
      userIcon,
      aianswerIcon,
      copyIcon,
      listOfSituations: [], // 情形树
      situationIds: [], // 当前选择过的情形id
      handleFlag: false, // 是否已经选择过situation
      situationIndex: 0, // 当前选中的situation的index
      situationChecked: [], // 选中的情况
      optionvalfileids: [], // 选中的材料id情况
      optionId: '', // 当前选择的情形选项id
      optionvalIds: [], // 当前选择过的情形选项值id
      selectvalId: '', // 当前选择的情形选项值id
      selectvalIds: [], // 当前选择的情形选项值id集合
      materialTitle: '',
      feildDataList: [], // 字段填写问题集合
      formIndex: 0,
      areaCode: '',
      status: 'open', // 窗口状态
      question: '', // 输入框问题
      list: [], // 对话流
      formList: [], // 表单问答对话流
      msg: {},
      robotId: '',
      placeholderValue: '请输入问题...',
      showStop: false,
      showQuit: false,
      token: '',
      quitJson: '',
      quitTitle: '根据您当前账号信息，已经为您填写部分表单内容，接下来请您按顺序回答相关信息，让我帮助您进行表单填写。',
      sseClient: null // SSE客户端
    }
  },
  created () {
    this.initMaterialInfo()
  },
  watch: {
    question (newVal) {
      // 在这里可以执行其他你需要的操作
      if (newVal.length > 24) {
        const inputDiv = document.getElementById('q')
        inputDiv.style.height = '60px'
      } else {
        const inputDiv = document.getElementById('q')
        inputDiv.style.height = '44px'
      }
    }
  },
  mounted () {
    this.setStyle()
    if (this.robotType === '1') {
      this.setFeildDataList()
    }
    setTimeout(() => {
      this.areaCode = this.itemBean.districtId
      this.getAreaCode()
    }, 2000)
  },
  beforeDestroy () {
    console.log('销毁前')
  },
  methods: {
    // 初始化表单问题
    setFeildDataList () {
      const formfillFlag = sessionStorage.getItem(this.$route.query.itemId + '_formfillFlag')
      if (formfillFlag) {
        this.quitTitle = '当前表单内容已填写完成，我还可以为您提供其他的填报咨询功能，请问您需要什么帮助？'
        return
      }
      this.feildDataList.push('请问新生儿性别、出生日期和医疗机构名称分别是？')
      this.feildDataList.push('新生儿的出生孕周、健康状况（健康、良好、较差、残疾）、体重（克）、身长（厘米）分别是？')
      this.feildDataList.push('新生儿姓名和出生地址分别是？')
      console.log('this.$route.query.itemId', this.$route.query.itemId)
      const situationSelect = sessionStorage.getItem(this.$route.query.itemId + '_listOfSituations')
      if (situationSelect) {
        try {
          let feildFalg = false
          const selectSitutionList = JSON.parse(situationSelect)
          selectSitutionList.forEach(selectBean => {
            if (selectBean.checked === '031b3ab3baa19b4033b7a01b3ccb3040') {
              console.log('selectBean', selectBean)
              feildFalg = true
            }
          })
          if (feildFalg) {
            this.feildDataList.push('住院病历号是多少？')
            this.feildDataList.push('住院医疗费金额是多少？（金额单位：元）')
            this.feildDataList.push('请提供下可汇款的银行账号及开户行名称？（建议使用中国农业银行）')
          }
        } catch (error) {
          console.log('parse err:', error)
        }
      }
      this.addlistdata({ role: 'robot', msg: this.feildDataList[this.formIndex] })
      this.formIndex++
    },
    // 初始化样式
    setStyle () {
      console.log('this.$eleId', this.eleId)
      const that = this
      const bodyDiv = document.querySelector(`#${this.eleId}`)
      console.log('bodyDiv', bodyDiv)

      // 拖拽
      let offsetX = 0
      let offsetY = 0
      if (bodyDiv) {
        bodyDiv.addEventListener('dragstart', function (event) {
          offsetX = event.clientX - bodyDiv.getBoundingClientRect().left
          offsetY = event.clientY - bodyDiv.getBoundingClientRect().top
        })

        document.addEventListener('dragover', function (event) {
          event.preventDefault()
        })

        document.addEventListener('drop', function (event) {
          console.log(1111, that.status)
          event.preventDefault()
          if (that.status === 'retract') {
            bodyDiv.style.left = (event.clientX - offsetX) + 'px'
            bodyDiv.style.top = (event.clientY - offsetY) + 'px'
          }
        })
      }

      // 监听选中文字
      document.addEventListener('selectionchange', function () {
        var selectedText = window.getSelection().toString()
        var floatingBox = document.getElementById('floatingBox')

        if (selectedText) {
          console.log('选中的文字是：' + selectedText)
          var range = window.getSelection().getRangeAt(0)
          // var parentElement = range.commonAncestorContainer.parentElement

          // 创建浮动的div盒子
          if (!floatingBox) {
            floatingBox = document.createElement('div')
            floatingBox.id = 'floatingBox'
            document.body.appendChild(floatingBox)
          }
          floatingBox.innerHTML = `<img class="ai" src="${that.aianswerIcon}" style="max-width: 70px;cursor:pointer;">` + `<img class="copy" src="${that.copyIcon}" style="max-width: 70px;cursor:pointer;">`
          floatingBox.style.position = 'absolute'
          var boundingRect = range.getBoundingClientRect()
          console.log('boundingRect', boundingRect)
          console.log('floatingBox.offsetHeight', floatingBox.offsetHeight)
          floatingBox.style.top = boundingRect.top + window.scrollY - floatingBox.offsetHeight - 15 + 'px'
          floatingBox.style.left = boundingRect.left + 'px'
          floatingBox.style.backgroundColor = '#ffffff'
          floatingBox.style.borderRadius = '5px'
          floatingBox.style.padding = '5px 10px'
          floatingBox.style.zIndex = '999'

          if (floatingBox) {
          // 添加点击事件
            var aiClick = floatingBox.querySelector('.ai')
            var copyClick = floatingBox.querySelector('.copy')
            aiClick.addEventListener('click', function () {
              console.log('点击了AI问答')
              that.$parent.handleOpenRobot()
              if (that.robotType === '1') {
                that.pullQuestion(selectedText, true)
              } else {
                that.pullQuestion(selectedText)
              }
            })
            copyClick.addEventListener('click', function () {
              console.log('点击了复制')
              const textarea = document.createElement('textarea')
              textarea.value = selectedText
              document.body.appendChild(textarea)
              textarea.select()
              try {
                document.execCommand('copy')
              } catch (err) {
                console.error('复制文字失败:', err)
              }
              document.body.removeChild(textarea)
            })
          }
        } else {
          // 取消选中时让盒子消失或销毁
          if (floatingBox) {
            floatingBox.remove()
          }
        }
      })
    },
    clearPlaceholder () {
      this.placeholderValue = ''
      // this.handleDialog('open')
    },
    blurPlaceholder () {
      this.placeholderValue = '请输入问题...'
    },
    // 收起、打开窗口
    handleDialog (v) {
      this.status = v
      const bodyDiv = document.querySelector(`#${this.eleId}`)
      if (v === 'open') {
        bodyDiv.style.right = '30px'
        bodyDiv.style.left = 'auto'
        this.openDialog()
      } else {
        const mainDiv = document.querySelector('.talkMain')
        bodyDiv.style.height = '400px'
        mainDiv.style.height = 'calc(100% - 102px)'
        bodyDiv.style.top = 'auto'
        bodyDiv.style.left = 'auto'
        bodyDiv.style.bottom = '30px'
      }
    },
    // 打开窗口
    openDialog () {
      this.closeRobot('open')
    },
    // 关闭窗口
    closeRobot (state) {
      // 销毁Vue实例
      // window.closeNewDialog()
      try {
        this.$emit('closeRobot', { robot: state })
      } catch (error) {
        // 捕获并记录异常
        console.error('An error occurred while emitting the event:', error)
      }
    },
    // 在线办理
    handleSubmit () {
      this.handleFlag = false
      if (this.userIsLogin()) {
        console.log('已登录')
        this.routingHop('formConfig')
      } else {
        console.log('未登录')
        const objhandle = {
          role: 'robot',
          msg: '',
          showfillbtn: ''
        }
        const currentDomain = window.location.origin
        // const currentDomain = 'https://zwfw.hanweb.com/'
        objhandle.msg = '您当前尚未登录，请前往登录页面进行账号登录 <br>[账号登录](' + currentDomain + '/jis-web/login?redirectUrl=' + window.location.href + ')'
        this.addlistdata(objhandle)
        console.log('list', this.list)
      }
    },
    setMatterSession (itemConfig) {
      const obj = {}
      obj.tag = this.taskServiceObj
      obj.groupName = this.itemBean.deptName
      obj.applyName = this.itemBean.itemName
      obj.applySource = 'PC'
      obj.itemType = this.handleType
      obj.matterId = this.itemBean.iid
      obj.matterName = this.itemBean.itemName
      obj.taskCode = this.itemBean.taskCode
      obj.code = '11'
      obj.flowId = itemConfig.flowId
      obj.metaId = itemConfig.metaId
      const matter = JSON.stringify(obj)
      sessionStorage.setItem(this.itemBean.iid + '_matter', matter)
    },
    routingHop (fillType) {
      console.log('routingHop')
      const itemId = this.itemBean.iid
      jiopWebAPI.findReportConfigByIid({ itemid: itemId }).then(res => {
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        this.setMatterSession(res.data.data)
        sessionStorage.setItem(itemId + '_reportSystem', res.data.data.reportSystem)
        if (this.situationChecked && this.situationChecked.length > 0) {
          // 存入情形
          sessionStorage.setItem(itemId + '_listOfSituations', JSON.stringify(this.situationChecked))
          sessionStorage.setItem(itemId + '_optionvalfileids', this.optionvalfileids)
        }
        let total = 0
        if (fillingInstruction === 'on') {
          total++
        }
        if (situation === 'on') {
          total++
        }
        if (formConfig === 'on') {
          total++
        }
        if (uploadMaterial === 'on') {
          total++
        }
        if (pickupMethod === 'on') {
          total++
        }
        if (inforMationConfirmed === 'on') {
          total++
        }
        const query = {
          itemId: itemId,
          stepNo: 0,
          total: total,
          handleType: this.handleType,
          flowId: res.data.data.flowId,
          intelligentApproval: res.data.data.intelligentApproval,
          acceptFlowId: res.data.data.acceptFlowId,
          wholeIntelligentApproval: res.data.data.wholeIntelligentApproval
        }
        const params = {
          materialList: ''
        }
        if (fillType === 'formConfig') {
          if (formConfig === 'on') {
            query.stepNo = 2
            this.$router.push({ path: '/matterForm', query: query, params: params })
          } else if (uploadMaterial === 'on') {
            query.stepNo = 3
            this.$router.push({ path: '/uploadMaterial', query: query, params: params })
          } else {
            this.$router.push({ path: '/fillInstruction', query: query, params: params })
          }
        } else {
          if (situation === 'on') {
            query.stepNo = 1
            this.$router.push({ path: '/selectSitution', query: query, params: params })
          } else if (formConfig === 'on') {
            query.stepNo = 2
            this.$router.push({ path: '/matterForm', query: query, params: params })
          } else if (uploadMaterial === 'on') {
            query.stepNo = 3
            this.$router.push({ path: '/uploadMaterial', query: query, params: params })
          } else {
            this.$router.push({ path: '/fillInstruction', query: query, params: params })
          }
        }
      })
    },
    async initMaterialInfo () {
      if (this.robotType === '2') {
        const jiopwebMaterialSession = JSON.parse(sessionStorage.getItem(this.itemBean.iid + '_JiopwebMaterial'))
        if ((this.materialList && this.materialList.length > 0) || (jiopwebMaterialSession && jiopwebMaterialSession.length > 0)) {
          let mustNum = 0
          const needFileNameList = []
          let useNum = 0
          if (jiopwebMaterialSession && jiopwebMaterialSession.length > 0) {
            jiopwebMaterialSession.forEach(itemMater => {
              if (itemMater.ismust === '01' || itemMater.ismust === '03') {
                mustNum++
              }
              if (itemMater.data && itemMater.data.length > 0) {
                useNum++
              } else {
                needFileNameList.push(itemMater.name)
              }
            })
          } else {
            this.materialList.forEach(itemMater => {
              if (itemMater.materialNecessity === '01' || itemMater.materialNecessity === '03') {
                mustNum++
              }
              if (itemMater.uploadResultVoList && itemMater.uploadResultVoList.length > 0) {
                useNum++
              } else {
                needFileNameList.push(itemMater.materialName)
              }
            })
          }
          if (mustNum > 0) {
            let fileInfo = '根据您选择的办事情形，本次申报共需提交' + mustNum + '份材料，'
            if (useNum > 0) {
              fileInfo += '通过数据共享已为您自动上传' + useNum + '份材料，'
            }
            if (needFileNameList.length > 0) {
              fileInfo += '您还需要上传以下' + needFileNameList.length + '份材料：'
              needFileNameList.forEach((filename, index) => {
                fileInfo += '<br>' + (index + 1) + '、' + filename
              })
            } else {
              fileInfo += '所有必要材料都已上传，请您确认下已上传的材料文件！若无问题，您可以点击下一步按钮，填写取件信息！'
            }
            this.materialTitle = fileInfo
          } else {
            this.materialTitle = '无必须提交材料，若无问题，您可以点击下一步按钮，填写取件信息！'
          }
        } else {
          if (this.materialTitle === '') {
            this.materialTitle = '无材料文件需要提交，若无问题，您可以点击下一步按钮，填写取件信息！'
          }
        }
      }
    },
    findMaterialInfo () {
      if (this.robotType === '2') {
        const jiopwebMaterialSession = JSON.parse(sessionStorage.getItem(this.itemBean.iid + '_JiopwebMaterial'))
        if (jiopwebMaterialSession) {
          const needFileNameList = []
          let useNum = 0
          jiopwebMaterialSession.forEach(itemMater => {
            if (itemMater.data && itemMater.data.length > 0) {
              useNum++
            } else {
              needFileNameList.push(itemMater.name)
            }
          })
          let fileInfo = ''
          if (needFileNameList.length > 0) {
            fileInfo += '您已上传了' + useNum + '份材料，还有以下' + needFileNameList.length + '份材料未上传：'
            needFileNameList.forEach((filename, index) => {
              fileInfo += '<br>' + (index + 1) + '、' + filename
            })
          } else {
            fileInfo += '所有材料都已上传完成，您可以点击下一步按钮，填写取件信息！'
          }
          this.addlistdata({ role: 'robot', msg: fileInfo })
        }
      }
    },
    // 判断键盘事件
    handleKeyDown (event) {
      if (event.ctrlKey && event.key === 'Enter') {
        // 插入换行符
        this.question += '\n'
      } else if (event.key === 'Enter') {
        this.pullQuestion(this.question)
        event.preventDefault()
      }
    },
    // 提交问题
    pullQuestion (v, askFlag) {
      const q = v.replace(/\n/g, '')
      if (!q) {
        this.question = ''
        return
      }
      // 判定是否做办理
      if (v.includes('开始办理') || v.includes('我要办理')) {
        if (!this.handleFlag) {
          this.handleFlag = true
          this.listOfSituations = cloneDeep(this.situationDataBeanList)
        }
      }
      if (askFlag) {
        v = v + '要怎么填？'
      }
      const obj = {
        role: 'user',
        msg: v.replace(/\n/g, '<br>')
      }
      this.addlistdata(obj)
      if (askFlag) {
        this.ask(v, askFlag)
        this.question = ''
        return
      }
      if (this.robotType === '1' && this.feildDataList.length > 0) {
        this.formList.push({ question: this.feildDataList[this.formIndex - 1], answer: obj.msg })
        if (this.feildDataList.length > this.formIndex) {
          setTimeout(() => {
            this.addlistdata({ role: 'robot', msg: this.feildDataList[this.formIndex] })
            this.formIndex++
          }, 500)
        } else {
          setTimeout(() => {
            this.addlistdata({ role: 'robot', msg: '' })
            this.quit()
          }, 500)
        }
      } else if (this.handleFlag && this.robotType === '3') {
        setTimeout(() => {
          this.handleStart()
        }, 1000) // 2000 毫秒（2 秒）后显示组件
      } else {
        this.ask(v)
      }
      this.question = ''
    },
    // 问答
    ask (v, askFlag) {
      const that = this
      this.token = new Date().getTime()
      const objmsg = {
        role: 'robot',
        msg: ''
      }
      that.list.push(objmsg)
      if (askFlag || that.robotType === '3' || that.robotType === '2') {
        v = this.itemBean.itemName + '事项下的' + v
      }
      that.showStop = true
      console.log('sse数据：', this.itemBean.iid)
      that.getAreaCode()
      this.sseClient = sseAPI.ask({
        data: {
          appId: this.robotRootId,
          q: v,
          token: this.token,
          regionCode: this.areaCode
        },
        message (msg) {
          if (msg.type === 'message') {
            const value = msg.data.data
            console.log('sse数据：', value)
            if (value && value.flag === 'middle') {
              that.list[that.list.length - 1].role = 'robot'
              that.list[that.list.length - 1].msg += value.answer.replace(/\\n/g, '<br>')
            } else if (value && value.flag === 'end') {
              that.showStop = false
              that.list[that.list.length - 1].role = 'robot'
              that.list[that.list.length - 1].msg = value.answer.replace(/\\n/g, '<br>')
              console.log('内容数据', that.list, that.feildDataList.length, that.formIndex)
              if (that.robotType === '1' && that.feildDataList.length >= that.formIndex) {
                const objhandle = {
                  role: 'robot',
                  msg: '您当前申报表还有信息未填完，请问需要让我帮助您继续填写吗？',
                  rillMark: 'true'
                }
                setTimeout(() => {
                  that.addlistdata(objhandle)
                }, 200)
              }
            }

            // 滚动条跟随
            const mainDiv = document.querySelector('.talkMain')
            setTimeout(() => {
              mainDiv.scrollTop = mainDiv.scrollHeight
            }, 30)
          }
        }
      })
    },
    rillMark () {
      if (this.robotType === '1' && this.feildDataList.length >= this.formIndex) {
        this.addlistdata({ role: 'robot', msg: this.feildDataList[this.formIndex - 1] })
      }
    },
    stopTalk () {
      this.showStop = false
      if (this.sseClient) {
        this.sseClient.abort()
        this.sseClient = null
      }
    },
    // 确认表单
    quit () {
      const that = this
      this.token = new Date().getTime()
      that.showStop = true
      let questionText = ''
      this.formList.forEach(robotData => {
        questionText += robotData.question + ': ' + robotData.answer + '<br>'
      })
      this.sseClient = sseAPI.ask({
        data: {
          appId: this.robotRootId,
          q: questionText,
          token: this.token,
          regionCode: ''
        },
        message (msg) {
          if (msg.type === 'message') {
            const value = msg.data.data
            console.log('sse数据：', value)
            if (value && value.flag === 'end') {
              that.showStop = false
              if (that.robotType === '1') {
                that.quitJson = value.answer
                let obj = {}
                try {
                  obj = JSON.parse(value.answer)
                } catch (error) {
                  console.error('JSON 解析错误')
                  obj = {} // 提供一个默认值
                }
                that.list[that.list.length - 1].role = 'robot'
                let formText = '好的。根据您的相关问答，我们已经为您补充申请表中所需的信息，请确认无误后点击“确定”按钮完成表单填报。'
                formText += '<br>新生儿性别：' + obj.xsexb + '<br>出生日期：' + obj.cssj + '<br>医疗机构名称：' + obj.yljgmc + '<br>出生孕周：' + obj.csyz + '<br>健康状况：' + obj.jk
                formText += '<br>体重（克）：' + obj.cstz + '<br>身长（厘米）：' + obj.cssc + '<br>新生儿姓名：' + obj.xsexm + '<br>出生地址：' + obj.csdd
                if (that.formIndex > 3) {
                  formText += '<br>住院病历号：' + obj.blh + '<br>医疗金额（元）：' + obj.ylfje + '<br>开户行名称：' + obj.khhmc + '<br>银行账号：' + obj.zh
                }
                console.log('formIndex', this.formIndex)
                that.list[that.list.length - 1].msg = formText
                that.showQuit = true
              }
              console.log('内容数据', that.list)
            }
            // 滚动条跟随
            const mainDiv = document.querySelector('.talkMain')
            setTimeout(() => {
              mainDiv.scrollTop = mainDiv.scrollHeight
            }, 50)
          }
        }
      })
    },
    quitBd () {
      window.returnRobotData(this.quitJson)
      this.showQuit = false
      this.feildDataList = []
      sessionStorage.setItem(this.itemBean.iid + '_formfillFlag', true)
    },
    getCookieData (cookieName) {
      try {
        var name = cookieName + '='
        var cookieMsg = document.cookie.replace(/%/g, '%25')
        var decodedCookie = decodeURIComponent(cookieMsg)
        var cookieArray = decodedCookie.split(';')
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i]
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
          }
        }
        return ''
      } catch (err) {
        console.log(err, 'cookieErr')
      }
    },
    parseMarkdown (htmlText) {
      // 使用marked解析Markdown文本
      const htmlContent = marked(htmlText, {
        // 使用highlight.js进行代码高亮
        highlight: function (code, lang) {
          if (hljs.getLanguage(lang)) {
            return hljs.highlight(code, { language: lang }).value
          }
          return hljs.highlightAuto(code).value // 使用自动语言检测
        }
      })
      return htmlContent
    },
    consultQuestion () {
      this.question = ''
      this.handleFlag = false
      this.situationIds = []
      this.optionvalIds = []
      this.situationChecked = []
      this.listOfSituations = []
      this.situationIndex = 0
      this.addlistdata({ role: 'robot', msg: '还有其他问题需要帮你解答吗？' })
    },
    addlistdata (robotobj) {
      this.list.push(robotobj)
      // 滚动条跟随
      const mainDiv = document.querySelector('.talkMain')
      setTimeout(() => {
        mainDiv.scrollTop = mainDiv.scrollHeight
      }, 50)
    },
    handleStart () {
      const objhandle = {
        role: 'robot',
        msg: '',
        situation: {},
        showfillbtn: ''
      }
      const index = this.situationIndex
      // 开始做办理指引
      if (this.handleFlag && this.situationDataBeanList && this.situationDataBeanList.length > 0) {
        const situationDataBean = this.situationTree()
        if (!situationDataBean.iid) {
          objhandle.msg = '办理指引已经完成，是否前往申报信息填写？'
          objhandle.situation = null
          objhandle.showfillbtn = 'true'
        } else {
          const situationData = {
            iid: situationDataBean.iid,
            active: situationDataBean.active,
            situationName: situationDataBean.situationName,
            selectType: situationDataBean.selectType,
            childList: situationDataBean.childList
          }
          objhandle.situation = situationData
        }
        this.situationIndex = index + 1
      } else {
        if (this.userIsLogin()) {
          this.routingHop('')
        } else {
          const currentDomain = window.location.origin
          objhandle.msg = '您当前尚未登录，是否需要前往[登录](' + currentDomain + '/jis-web/login?redirectUrl=' + window.location.href + ')'
        }
      }
      this.addlistdata(objhandle)
    },
    userIsLogin () {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      if (userInfo.isLogin) {
        return true
      } else {
        return false
      }
    },
    // 单选选中处理方式
    handleRadioChecked (checkedId, item) {
      console.log('单选选中处理方式', checkedId, item)
      if (!this.situationIds.includes(item.iid)) {
        let selectedText = ''
        item.childList.forEach(itemSituation => {
          if (itemSituation.iid === checkedId) {
            selectedText = itemSituation.situationName
            if (itemSituation.optionvalfileid) {
              if (this.optionvalfileids === '') {
                this.optionvalfileids = itemSituation.optionvalfileid
              } else {
                this.optionvalfileids += ',' + itemSituation.optionvalfileid
              }
            }
          }
        })
        const obj = {
          role: 'user',
          msg: selectedText
        }
        this.addlistdata(obj)
        this.optionvalIds.push(checkedId)
        this.selectvalId = checkedId
        this.optionId = item.iid
        setTimeout(() => {
          this.handleStart()
        }, 1000) // 2000 毫秒（2 秒）后显示组件
        // 记录选中的情形
        this.situationIds.push(item.iid)
      }
    },
    handleCheckboxChange (checkedList, item) {
      if (!this.situationIds.includes(item.iid)) {
        let selectedText = ''
        item.childList.forEach(itemSituation => {
          if (checkedList.includes(itemSituation.iid)) {
            if (selectedText !== '') {
              selectedText = selectedText + ',' + itemSituation.situationName
            } else {
              selectedText = itemSituation.situationName
            }
            if (itemSituation.optionvalfileid) {
              if (this.optionvalfileids === '') {
                this.optionvalfileids = itemSituation.optionvalfileid
              } else {
                this.optionvalfileids += ',' + itemSituation.optionvalfileid
              }
            }
          }
        })
        const obj = {
          role: 'user',
          msg: selectedText
        }
        this.addlistdata(obj)
        checkedList.forEach(checkedId => {
          this.optionvalIds.push(checkedId)
        })
        this.selectvalIds = checkedList
        this.optionId = item.iid
        setTimeout(() => {
          this.handleStart()
        }, 1000) // 2000 毫秒（2 秒）后显示组件
        // 记录选中的情形
        this.situationIds.push(item.iid)
      }
    },
    // 多选点击
    handleStyleClick (sub, list) {
      list.map(item => {
        item.active = 'none'
      })
      sub.active = 'active'
    },
    situationTree () {
      let obj = {}
      if (this.situationIndex > 0) {
        let checkedList = []
        let childFalg = false
        const getChildId = tree => {
          if (tree && tree.length) {
            tree.some(optionitem => {
              if (childFalg) {
                return true
              }
              // 情形选项
              if (optionitem.situationType === 'option') {
                console.log('optionId', this.optionId)
                if (this.optionId === optionitem.iid) {
                  if (optionitem.selectType === 'single') {
                    optionitem.checked = this.selectvalId
                  } else {
                    optionitem.checked = this.selectvalIds
                  }
                  const checkedoption = cloneDeep(optionitem)
                  this.situationChecked.push(checkedoption)
                }
                if (optionitem.checked) {
                  if (optionitem.selectType === 'single') {
                    checkedList.push(optionitem.checked)
                  } else {
                    checkedList = optionitem.checked
                  }
                } else {
                  obj = cloneDeep(optionitem)
                  childFalg = true
                  return true
                }
                if (optionitem.childList && optionitem.childList.length > 0) {
                  getChildId(optionitem.childList)
                }
              }
              // 情形选项值
              if (optionitem.situationType === 'value') {
                if (checkedList.includes(optionitem.iid) && optionitem.childList && optionitem.childList.length > 0) {
                  getChildId(optionitem.childList)
                }
              }
            })
          }
        }
        getChildId(this.listOfSituations)
      } else {
        // 第一个情形选项
        obj = this.listOfSituations[0]
      }
      return obj
    },
    getOptionBean (optionBeanList) {
      const optionchildList = []
      let parentId = '0'
      optionBeanList.forEach(databean => {
        if (databean.situationType === 'option') {
          parentId = databean.situationParentId
          const clonebean = cloneDeep(databean)
          optionchildList.push(clonebean)
        }
      })
      const optionobj = {
        parentId: parentId,
        childList: optionchildList
      }
      return optionobj
    },
    getAreaCode () {
      if (this.areaCode === '' || this.areaCode === undefined) {
        const itemId = this.itemBean.iid
        if (itemId === '' || itemId === null || itemId === undefined) {
          return
        }
        try {
          if (this.handleType === 'onething') {
            jiopAPI.oneThingGuide({ iid: itemId }).then(res => {
              if (res.success) {
                this.areaCode = res.data.oneThings.districtId
              }
            })
          } else {
            jiopWebAPI.findItemBeanSimple({ itemId: itemId }).then(res => {
              if (res.success) {
                this.areaCode = res.data.itemInfoBean.districtId
              }
            })
          }
        } catch (error) {
          console.log('getAreaCode err', error)
        }
      }
    }
  }
}
</script>
<style lang="less" scope>
@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.disabled {
  pointer-events: none; /* 阻止点击事件 */
  opacity: 0.8; /* 可选，为了视觉上表示不可点击 */
}
.radiobtn {
  position: relative;
  display: inline-block;
  height: 32px;
  margin: 0;
  margin-right: 8px;
  margin-top: 8px;
  padding: 0 15px;
  line-height: 30px;
  background: #e6f7ff;
  border: 1px solid #e6f7ff;
  border-top-width: 1.02px;
  // width: 72px;
  background: #1777FF;
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition: color 0.3s, background 0.3s, border-color 0.3s, -webkit-box-shadow 0.3s;
  transition: color 0.3s, background 0.3s, border-color 0.3s, -webkit-box-shadow 0.3s;
  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
  transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s, -webkit-box-shadow 0.3s;
  .textdiv{
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    // width: 50px;
  }
}

.spantext {
  font-size: 14px;
  font-weight: 500;
  color: rgb(0, 132, 255);
}

.focus-animation {
  display: inline-block;
  width: 0.1em; /* 光标宽度 */
  height: 1.2em; /* 光标高度 */
  background-color: black; /* 光标颜色 */
  animation: blink 1s infinite; /* 光标闪烁动画 */
  margin-bottom: -0.2em; /* 使光标垂直居中 */
}
.robotItemHelper {
  width: 420px;
  // height: 85%;
  min-height: 380px;
  background: #FFFFFF;
  padding: 3px;
  border-radius: 5px;
  position: fixed;
  // top: 100px;
  right: 30px;
  z-index: 99;
  box-shadow: 0 0 5px #1890ff;
  .title {
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    background: linear-gradient(to right, #f3f7f9, #fdfefe);
    .robotIcon {
      margin-bottom: 30px;
      width: 70px;
      cursor: pointer;
    }
  }
  .titleUp {
    position: relative;
    img {
      position: absolute;
      top: -41px;
      left: -51px;
    }
  }
  .cont {
    height: calc(100% - 45px);
    width: 100%;
    background: linear-gradient(to bottom, #dce8ff, #f1f6ff);
    padding: 15px 0;
    .talkMain {
      width: 100%;
      height: calc(100% - 103px);
      min-height: 350px;
      max-height: 450px;
      overflow-y: auto;
      padding: 0 15px;
      .main_title {
        width: 335px;
        padding: 10px;
        background: #FFFFFF;
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
        border-bottom-left-radius: 7px;
        margin-bottom: 15px;
      }
      .main_cont {
        max-width: 335px;
        width: fit-content;
        padding: 10px;
        background: #FFFFFF;
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
        border-bottom-left-radius: 7px;
        margin-bottom: 15px;
        .cont_select {
          margin-bottom: 0px;
          word-wrap: break-word;
        }
        .selectBtn {
          background: #1777FF;
          border-radius: 4px;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
        }
        .unselectBtn {
          background: #F2F2F2;
          border-radius: 4px;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }
      }
      .main_user {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 15px;
        .user_question {
          max-width: 335px;
          width: fit-content;
          display: inline-block;
          color: #FFFFFF;
          padding: 10px;
          background: #1777FF;
          border-top-left-radius: 7px;
          border-bottom-right-radius: 7px;
          border-bottom-left-radius: 7px;
          border-radius: 8px;
          margin-right: 10px;
        }
        .userIcon {
          display: inline-block;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
    .input {
      position: relative;
      height: 100px;
      padding: 0 15px;
      margin-top: 10%;
      #q {
        width: 100%;
        height: 44px;
        border-radius: 20px;
        overflow-y: auto;
        border: 0px solid #CFCFCF;
        padding: 10px;
        padding-right: 45px;
        outline: none;
        resize: none;
      }
      .pullimg {
        position: absolute;
        top: 61px;
        right: 23px;
        width: 24px;
        height: 24px;
      }
      .stop {
        // position: absolute;
        // left: 156px;
        // top: -49px;
        width:  99px;
        height: 38px;
        cursor: pointer;
      }
      .stoptwo {
        width:  95px;
        height: 30px;
        cursor: pointer;
      }
      .quit {
        border: 1px solid #1890ff;
        color: #1890ff;
        background: #FFFFFF;
        width: 100px;
        height: 100%;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }

}
</style>
